import React from "react";
import { View, TouchableOpacity, StyleSheet, Text } from "react-native";
import {
  GRID_TEMPLATE_1,
  GRID_TEMPLATE_2,
  GRID_TEMPLATE_3,
  GRID_TEMPLATE_4,
  GridLayoutType,
} from "./GridTemplates";
import { useThemeSettings } from "../../ThemeProvider";
import { CustomIcon } from "../CustomIcon";
import CustomLinearGradient, { GRADIENT_TYPE } from "../CustomLinearGradient";
import { usePlatform } from "../../providers/PlatformProvider";

interface Props {
  value: GridOption;
  onChange: (v: GridOption) => void;
}

export interface GridOption {
  key: string;
  template: GridLayoutType[];
}

export const GRID_OPTIONS: GridOption[] = [
  { key: "template1", template: GRID_TEMPLATE_1 },
  { key: "template2", template: GRID_TEMPLATE_2 },
  { key: "template3", template: GRID_TEMPLATE_3 },
  { key: "template4", template: GRID_TEMPLATE_4 },
  /*  { key: "template5", template: GRID_TEMPLATE_5 },
     { key: "template6", template: GRID_TEMPLATE_6 }, */
];

export default function GridLayoutSelector({ value, onChange }: Props) {
  const { theme } = useThemeSettings();
  const { showWebVersion } = usePlatform();
  return (
    <CustomLinearGradient
      gradientType={GRADIENT_TYPE.MODAL}
      angle={90}
      style={[styles.container, { borderColor: theme?.colors?.primary }]}
    >
      <Text style={[styles.title, { color: theme.colors.primary }]}>
        Grid Layout
      </Text>

      <View style={styles.grid}>
        {GRID_OPTIONS.map((opt, i) => (
          <TouchableOpacity
            key={`opt${i}`}
            style={[
              styles.option,
              value === opt && {
                ...styles.activeOption,
                borderColor: theme?.colors?.primary,
                backgroundColor: theme?.colors?.btnBgFill,
              },
            ]}
            onPress={() => onChange(opt)}
          >
            <CustomIcon
              icon={`${opt.key}${showWebVersion ? "Web" : ""}`}
              size={32}
              color={
                value === opt ? theme.colors.primary : theme.colors.textPrimary
              }
            />
          </TouchableOpacity>
        ))}
      </View>
    </CustomLinearGradient>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 16,
    borderRadius: 16,
    borderWidth: 1,
    width: 170,
  },
  title: {
    fontSize: 18,
    fontWeight: "600",
    marginBottom: 12,
  },
  grid: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  option: {
    width: 60,
    height: 60,
    borderRadius: 16,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 12,
  },
  activeOption: {
    borderWidth: 2,
  },
});
